import React from 'react'

import './styles.scss'
import ExclamationTriangleIcon from 'components/icons/ExclamationTriangleIcon'

/**
 * Display Error text
 * @param {object} props
 * @param {React.Component} props.children
 * @param {function} [props.text]
 *
 * @returns {React.Component}
 */
const ErrorWrapper = (props) => {
  const { text, children } = props

  return (
    <div className='nx-input-error-container'>
      <div className='nx-input-error-container__field'>
        { children }
        {
          text
            ? (
              <div className='nx-input-error-container__icon'>
                <ExclamationTriangleIcon />
              </div>
            )
            : null
        }
      </div>
      {
        text
          ? (
            <div className='nx-input-error'>
              {text}
            </div>
          )
          : null
      }
    </div>
  )
}

export default ErrorWrapper
